import classes from './multi-select.module.css'

const MultiSelect = {
  classNames: {
    input: classes.input,
  },
}

export default MultiSelect
